import { useState, useEffect } from "react";
import {
  TextField,
  IconButton,
  Box,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Search, Refresh } from "@mui/icons-material";
import moment from "moment";

const DateSearchComponentForDashboard = ({ onSearch }) => {
  // ✅ Default: yesterday → today
  const [startDate, setStartDate] = useState(
    moment().format("YYYY-MM-DD")
    // moment().subtract(1, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // ✅ Trigger default search once on mount
  useEffect(() => {
    onSearch(startDate, endDate);
  }, []); // run once

  const handleSearch = () => {
    if (startDate && endDate) {
      onSearch(startDate, endDate);
    }
  };

  const handleReset = () => {
    // const defaultStartDate = moment().subtract(1, "days").format("YYYY-MM-DD");
    const defaultStartDate = moment().format("YYYY-MM-DD");
    const defaultEndDate = moment().format("YYYY-MM-DD");
    setStartDate(defaultStartDate);
    setEndDate(defaultEndDate);
    onSearch(defaultStartDate, defaultEndDate);
  };

  return (
    <Box
      display="flex"
      alignItems={isMobile ? "stretch" : "center"}
      justifyContent={isMobile ? "flex-start" : "flex-end"}
      gap={isMobile ? 0.5 : 1}
    >
      {/* Start Date */}
      <TextField
        name="startDate"
        id="startDate"
        size="small"
        label="Start Date"
        type="date"
        value={startDate}
        onChange={(e) => setStartDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        fullWidth={isMobile}
      />

      {/* End Date */}
      <TextField
        size="small"
        name="endDate"
        id="endDate"
        label="End Date"
        type="date"
        value={endDate}
        onChange={(e) => setEndDate(e.target.value)}
        InputLabelProps={{ shrink: true }}
        variant="outlined"
        fullWidth={isMobile}
      />

      {/* Buttons */}
      <Box
        display="flex"
        flexDirection="row"
        justifyContent={isMobile ? "flex-end" : "center"}
        gap={isMobile ? 0.5 : 0}
      >
        <Tooltip title="Search">
          <IconButton
            color="primary"
            onClick={handleSearch}
            size={isMobile ? "small" : "medium"}
            sx={{ p: isMobile ? "0px" : "4px" }}
          >
            <Search />
          </IconButton>
        </Tooltip>

        <Tooltip title="Reset">
          <IconButton
            color="secondary"
            onClick={handleReset}
            size={isMobile ? "small" : "medium"}
            sx={{ p: isMobile ? "0px" : "4px" }}
          >
            <Refresh />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default DateSearchComponentForDashboard;





// import { useState } from "react";
// import {
//   TextField,
//   IconButton,
//   Box,
//   Tooltip,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import { Search, Refresh } from "@mui/icons-material";
// import moment from "moment";

// const DateSearchComponentForDashboard = ({ onSearch }) => {
//   // ✅ Default: 1-day gap between start and end date
//   const [startDate, setStartDate] = useState(
//     moment().subtract(1, "days").format("YYYY-MM-DD")
//   );
//   const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   const handleSearch = () => {
//     if (startDate && endDate) {
//       onSearch(startDate, endDate);
//     } else if (startDate) {
//       onSearch(startDate, null);
//     } else if (endDate) {
//       onSearch(null, endDate);
//     }
//   };

//   const handleReset = () => {
//     const defaultStartDate = moment().subtract(1, "days").format("YYYY-MM-DD");
//     const defaultEndDate = moment().format("YYYY-MM-DD");

//     setStartDate(defaultStartDate);
//     setEndDate(defaultEndDate);

//     onSearch(defaultStartDate, defaultEndDate);
//   };

//   return (
//     <Box
//       display="flex"
//       alignItems={isMobile ? "stretch" : "center"}
//       justifyContent={isMobile ? "flex-start" : "flex-end"}
//       gap={isMobile ? 0.5 : 1}
//     >
//       {/* Start Date */}
//       <TextField
//         name="startDate"
//         id="startDate"
//         size="small"
//         label="Start Date"
//         type="date"
//         value={startDate}
//         onChange={(e) => setStartDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//         fullWidth={isMobile}
//       />

//       {/* End Date */}
//       <TextField
//         size="small"
//         name="endDate"
//         id="endDate"
//         label="End Date"
//         type="date"
//         value={endDate}
//         onChange={(e) => setEndDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//         fullWidth={isMobile}
//       />

//       {/* Buttons */}
//       <Box
//         display="flex"
//         flexDirection="row"
//         justifyContent={isMobile ? "flex-end" : "center"}
//         gap={isMobile ? 0.5 : 0}
//       >
//         <Tooltip title="Search">
//           <IconButton
//             color="primary"
//             onClick={handleSearch}
//             size={isMobile ? "small" : "medium"}
//             sx={{ p: isMobile ? "0px" : "4px" }}
//           >
//             <Search />
//           </IconButton>
//         </Tooltip>

//         <Tooltip title="Reset">
//           <IconButton
//             color="secondary"
//             onClick={handleReset}
//             size={isMobile ? "small" : "medium"}
//             sx={{ p: isMobile ? "0px" : "4px" }}
//           >
//             <Refresh />
//           </IconButton>
//         </Tooltip>
//       </Box>
//     </Box>
//   );
// };

// export default DateSearchComponentForDashboard;

////////////////////////////






// import { useState } from "react";
// import {
//   TextField,
//   IconButton,
//   Box,
//   Tooltip,
//   useMediaQuery,
//   useTheme,
// } from "@mui/material";
// import { Search, Refresh } from "@mui/icons-material";
// import moment from "moment";

// const DateSearchComponentForDashboard = ({ onSearch }) => {
//   const [startDate, setStartDate] = useState(
//     moment().subtract(1, "days").format("YYYY-MM-DD")
//   );
//   const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ✅ Mobile detection

//   const handleSearch = () => {
//     if (startDate && endDate) {
//       onSearch(startDate || null, endDate || null);
//     } else if (startDate) {
//       onSearch(startDate || null, endDate || null);
//     } else if (endDate && !startDate) {
//       const calculatedStartDate = moment(endDate)
//         .subtract(3, "months")
//         .format("YYYY-MM-DD");

//       onSearch(calculatedStartDate, endDate);
//     }
//   };

//   const handleReset = () => {
//     const defaultStartDate = moment().subtract(30, "days").format("YYYY-MM-DD");
//     const defaultEndDate = moment().format("YYYY-MM-DD");

//     setStartDate(defaultStartDate);
//     setEndDate(defaultEndDate);
//     setStartDate("");
//     setEndDate("");

//     onSearch(null, null, defaultStartDate, defaultEndDate);
//   };

//   return (
//     <Box
//       display="flex"
//       // flexDirection={isMobile ? "column" : "row"} // ✅ Stack on mobile
//       alignItems={isMobile ? "stretch" : "center"}
//       justifyContent={isMobile ? "flex-start" : "flex-end"}
//       gap={isMobile ? 0.5 : 1} // ✅ More gap on mobile for better spacing
//       // width="100%"
//     >
//       {/* Start Date */}
//       <TextField
//         name="startDate"
//         id="startDate"
//         size="small"
//         label="Start Date"
//         type="date"
//         value={startDate}
//         onChange={(e) => setStartDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//         fullWidth={isMobile} // ✅ Full width on mobile
//       />

//       {/* End Date */}
//       <TextField
//         size="small"
//         name="endDate"
//         id="endDate"
//         label="End Date"
//         type="date"
//         value={endDate}
//         onChange={(e) => setEndDate(e.target.value)}
//         InputLabelProps={{ shrink: true }}
//         variant="outlined"
//         fullWidth={isMobile} // ✅ Full width on mobile
//       />

//       {/* Search + Reset Buttons */}
//       <Box
//         display="flex"
//         flexDirection="row"
//         justifyContent={isMobile ? "flex-end" : "center"}
//         gap={isMobile ? 0.5 : 0} // ✅ Less gap on mobile
//       >
//         {/* Search Icon Button */}
//         <Tooltip title="Search">
//           <IconButton
//             color="primary"
//             onClick={handleSearch}
//             size={isMobile ? "small" : "medium"} // ✅ Smaller buttons on mobile
//             sx={{
//               p: isMobile ? "0px" : "4px", // ✅ Less padding on mobile
//             }}
//           >
//             <Search />
//           </IconButton>
//         </Tooltip>

//         {/* Reset Icon Button */}
//         <Tooltip title="Reset">
//           <IconButton
//             color="secondary"
//             onClick={handleReset}
//             size={isMobile ? "small" : "medium"}
//             sx={{
//               p: isMobile ? "0px" : "4px", // ✅ Less padding on mobile
//             }}
//           >
//             <Refresh />
//           </IconButton>
//         </Tooltip>
//       </Box>
//     </Box>
//   );
// };

// export default DateSearchComponentForDashboard;


